<evi-desktop-modal
  id="file-browser"
  titleIconName="folder-open"
  [title]="'FILE_BROWSER.OPEN_FILE' | translate"
  (closed)="onClose()"
>
  <evi-desktop-file-browser
    [path]="(path$ | async) ?? []"
    [loading]="(loading$ | async) ?? false"
    [buttonBackDisabled]="disableBackButton"
    (selectFolder)="onSelectFolder($event)"
    (backToPreviousFolder)="backToPreviousFolder($event)"
  >
    <ng-container sources>
      @if (authorizations.local.active) {
        <evi-desktop-source-item
          iconName="server"
          [name]="'FILE_BROWSER.LOCAL' | translate"
          [isActive]="activeNavigation === 'local'"
          (itemClicked)="openLocal()"
        />
      }

      @if (authorizations.drive.active) {
        <evi-desktop-source-item
          iconName="cloud"
          [name]="'FILE_BROWSER.DRIVE' | translate"
          [isActive]="activeNavigation === 'drive'"
          (itemClicked)="openDrive()"
        />
      }
    </ng-container>

    <ng-container loadedLists>
      @if (activeNavigation) {
        <!-- Drive list of files -->
        <evi-desktop-file-list
          [authorization]="authorizations[activeNavigation]"
          [acceptedExtensions]="acceptedExtensions"
          [list]="(list$ | async) ?? []"
          [emptyText]="'FILE_BROWSER.NO_FILES' | translate"
          [isFolder]="isFolder"
          [isFile]="isFile"
          (selectFolder)="onSelectFolder($event)"
          (selectFile)="onSelectFile($event)"
        ></evi-desktop-file-list>
      } @else {
        <div class="file-browser-modal__list-empty">
          {{ 'FILE_BROWSER.SELECT_SOURCE_FOR_FILES' | translate }}
        </div>
      }

    </ng-container>
  </evi-desktop-file-browser>
</evi-desktop-modal>
